<template>
  <div :id="$style.promos">
    <Header />
    <div :class="$style.body">
      <div :class="[$style.block]">
        <h1>Edit Promo Codes</h1>
        <p>Select an item on the right that you would like to edit.</p>
        <form v-if="id" @submit.prevent="savePromo">
          <div :class="$style.field"><input v-model="id" type="text" /></div>
          <div :class="$style.field">
            <div>Products</div>
            <select v-model="attrs.products" :class="$style.products" multiple>
              <option v-for="product in productOptions" :key="product" :value="product">{{ product }}</option>
            </select>
          </div>
          <h3>Override Visitor Limits</h3>
          <div :class="$style.field">
            <div>Modifier (amount)</div>
            <input v-model="attrs.accountUpdates.visitorLimitModifier" type="text" />
          </div>
          <div :class="$style.field">
            <select v-model="attrs.accountUpdates.visitorLimitModifierType">
              <option v-for="option in modifierTypeOptions" :key="option">{{option}}</option>
            </select>
          </div>
          <div :class="$style.field"><input type="checkbox" v-model="attrs.accountUpdates.resetOnPlanChange" />Reset on plan change</div>
          <h3>Billing</h3>
          <div :class="$style.field">
            <div>Stripe Coupon Code</div>
            <input v-model="attrs.billing.customerCouponCode" type="text" />
          </div>
          <div :class="$style.field">
            <div>Trial Period (days)</div>
            <input v-model="attrs.billing.trialPeriod" type="number" />
          </div>
          <hr />
          <h2>Override Front End Messaging</h2>
          <div :class="$style.field">
            <div>Only allow on specific plan type</div>
            <input v-model="attrs.frontendMessaging.planType" type="text" />
            <div :class="$style.note">'annual' or 'monthly'</div>
            </div>
          <h3>Register Page</h3>
          <div :class="$style.field">
            <div :class="$style.field"><input v-model="attrs.frontendMessaging.hidePromo" type="checkbox" /> Do not display promo code</div>
          </div>
          <div :class="$style.field">
            <div>Subheadline</div>
            <input v-model="attrs.frontendMessaging.register.subheadline" type="text" />
          </div>
          <h3>Plans Page</h3>
          <div :class="$style.field">
            <div>Subheadline</div>
            <input v-model="attrs.frontendMessaging.plans.subheadline" type="text" />
          </div>
          <h3>Payment Page</h3>
          <div :class="$style.field">
            <div>Subheadline</div>
            <input v-model="attrs.frontendMessaging.payment.subheadline" type="text" />
          </div>
          <div :class="$style.field">
            <div>Button Text</div>
            <input v-model="attrs.frontendMessaging.payment.button" type="text" />
          </div>
          <div :class="$style.field">
            <div>Loading Message</div>
            <input v-model="attrs.frontendMessaging.payment.loadingMsg" type="text" />
          </div>
          <div :class="$style.field">
            <div>List of Benefits <button @click.prevent="attrs.frontendMessaging.payment.benefits.push('')">Add</button></div>
            <div v-for="(benefit, index) in attrs.frontendMessaging.payment.benefits" :key="index">
              <input v-model="attrs.frontendMessaging.payment.benefits[index]" type="text" /> <span :class="$style.xButton" @click="attrs.frontendMessaging.payment.benefits.splice(index, 1)">x</span>
            </div>
          </div>
          <hr />
          <div :class="$style.field"><button type="sumbit">Submit</button></div>
          <div :class="$style.field"><button @click.prevent="removePromo">Delete</button></div>
        </form>
      </div>
      <div :class="[$style.block, $style.short]">
        <div><input v-model="newPromoName" /><button @click="newPromo">New Promo</button></div>
        <ul :class="$style.list">
          <li v-for="(promo, id) in promoList" :key="id">
            <router-link :class="$style.title" :to="{ name: 'EditPromo', params: { id } }">{{id}}</router-link>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
  import _merge from 'lodash/merge'
  import Header from '../lib/Header'
  const firebase = window.firebase

  function initAttrs () {
    return {
      products: [],
      accountUpdates: {
        visitorLimitModifier: null,
        visitorLimitModifierType: null,
        resetOnPlanChange: null
      },
      billing: {
        customerCouponCode: null,
        trialPeriod: null
      },
      frontendMessaging: {
        hidePromo: null,
        planType: null,
        register: {
          subheadline: null
        },
        plans: {
          subheadline: null
        },
        payment: {
          subheadline: null,
          benefits: [],
          button: null,
          loadingMsg: null
        }
      }
    }
  }

  export default {
    name: 'Promos',
    components: {
      Header
    },
    data () {
      return {
        id: null,
        attrs: initAttrs(),
        promoList: {},
        newPromoName: null,
        productOptions: {
          FBADS: 'FBADS',
          WEBINAR_BOOTCAMP: 'WEBINAR_BOOTCAMP',
          SIX_K_SUCCESS: 'SIX_K_SUCCESS',
          HIGH_TICKET_MASTERY: 'HIGH_TICKET_MASTERY',
          SHARE_FUNNELS: 'SHARE_FUNNELS',
          CONVERSION_SECRETS: 'CONVERSION_SECRETS',
          EA: 'EA'
        },
        modifierTypeOptions: {
          [null]: null,
          multiply: 'multiply',
          add: 'add',
          limit: 'limit'
        }
      }
    },
    methods: {
      loadPromo (id) {
        this.id = this.$route.params.id
        if (this.promoList[this.id]) {
          this.attrs = _merge(initAttrs(), this.promoList[this.id])
        } else {
          this.attrs = initAttrs()
        }
      },
      savePromo () {
        if (confirm('Save this promo code?')) {
          firebase.database().ref('promos').child(this.id).set(this.attrs).then(() => {
            this.$toasted.show(`Promo code saved`, {
              duration: 3000,
              className: 'toasty'
            })
          }).catch(() => {
            this.$toasted.show(`Unable to save promo code`, {
              duration: 3000,
              className: 'toasty-error'
            })
          })
        }
      },
      removePromo () {
        if (this.id && confirm('Remove this promo code?')) {
          firebase.database().ref('promos').child(this.id).remove()
        }
      },
      newPromo () {
        this.$router.push({name: 'EditPromo', params: { id: this.newPromoName }})
      }
    },
    created () {
      firebase.database().ref('promos').on('value', snap => {
        this.promoList = snap.val()

        if (this.$route.params.id) {
          this.loadPromo(this.$route.params.id)
        }
      })
    },
    watch: {
      $route (to, from) {
        if (to.params.id) {
          this.loadPromo(to.params.id)
        }
      }
    }
  }
</script>

<style lang="scss" module>
  #promos {
    .body {
      display: flex;
      align-items: flex-start;
      .field {
        margin-top: 2rem;
        position: relative;
        .products {
          height: 150px;
          width: 300px;
        }
        .note {
          font-size: 10px;
        }
        .xButton {
          cursor: pointer;
          position: absolute;
          right: 5px;
          top: 20px;
        }
        input[type="text"] {
          display: block;
          width: 100%;
          padding: 0.7em;
          font-size: 1em;
          border: 1px solid #ddd;
          margin-bottom: 0.5em;
          border-radius: 3px;
          box-shadow: inset 0 1px 3px rgba(0, 0, 0, 0.06);
          outline: none;

          &:focus {
            border-color: #2196f3;
          }
        }
      }
      .block {
        flex-grow: 3;
        margin-top: 30px;
        padding: 20px 20px 40px;
        background-color: white;
        border-radius: 8px;
        -webkit-box-shadow: 0 2px 4px 0 rgba(14, 30, 37, 0.12);
        box-shadow: 0 2px 4px 0 rgba(14, 30, 37, 0.12);

        &:first-child {
          margin-right: 10px;
        }

        &.short {
          max-width: 400px;
          flex-grow: 1;
        }
        .list {
          padding: 0;
          list-style-type: none;
          li {
            display: block;
            padding: 3px 6px;
            margin-bottom: 3px;
            cursor: pointer;

            .title {
              background-color: rgba(black, 0.05);
              border-radius: 3px;
              color: black;
              display: inline-block;
              padding: 5px 8px;
              text-decoration: none;
              &:hover {
                background-color: rgba(black, 0.1);
              }
            }
          }
        }
      }
    }
  }
</style>


// WEBPACK FOOTER //
// src/components/Promos/index.vue